<i18n>
{
	"en": {
		"PleaseInputToSearch": "Please input to search"
	},
	"vi": {
		"PleaseInputToSearch": "Gõ tên phòng ban để tìm kiếm."
	}
}
</i18n>

<template>
	<div>
		<!-- Block tag employee, departement, title -->
		<div class="container-watcher--block-item">
			<h6 v-if="title" class="mb-2 custom-component--title">{{ title }}<span class="text-danger" v-if="isRequired">&nbsp;*</span>:</h6>
			<v-select
				:ref="ref"
				label="name"
				v-bind="$attrs"
				v-on="$listeners"
				:options="departments"
				:placeholder="`${$t('Actions.Choose')} ${$t('Department').toLowerCase()}`"
				:class="['bg-white', optionsClass]"
				:closeOnSelect="true"
				:getOptionKey="option => ref + option.id"
				:reduce="department => ({ id: department.id, name: department.name })"
			>
				<template v-slot:option="option">
					<div :class="`flex items-center pl-${option.depth > 1 ? option.depth * 2 : option.depth}`">
						<i class="mr-2 nucleo nucleo-shape-oval-3"></i>
						{{ option.name }}
					</div>
				</template>
				<span slot="no-options">{{ $t("Notify.NoMatchingOptions") }}</span>
			</v-select>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";

import * as _ from "lodash";
import { mapGetters } from "vuex";

export default {
	inheritAttrs: false,
	name: "CbsDepartments",
	props: {
		title: {
			type: String
		},
		placeholder: {
			type: String
		},

		noOptionsDepartment: {
			type: String
		},
		isRequired: {
			type: Boolean
		},
		optionsClass: {
			type: String
		}
	},
	components: {
		"v-select": vSelect
	},
	computed: {
		departments() {
			return (this.getFormattedFlattenTreeDepartments || []).map(department => ({
				id: department.id,
				name: department.name,
				depth: department.depth
			}));
		},
		...mapGetters({
			getFormattedFlattenTreeDepartments: "departmentManagement/getFormattedFlattenTreeDepartments"
		})
	},

	data() {
		return {
			ref: _.uniqueId("employeeDepartments_")
		};
	},
	methods: {
		handleAddingNewOption(newOptionText, listOptions) {
			const existedOption = listOptions.find(option => option.name === newOptionText);
			if (!existedOption) {
				return { name: newOptionText };
			}
			return existedOption;
		}
	},
	created() {
		this.$store.dispatch("departmentManagement/fetchDepartments", {});
	}
};
</script>
<style lang="scss">
.container-watcher--block-item {
	.vs__selected {
		.inline-block {
			line-height: 100%;
		}
		.nucleo {
			color: var(--color-white);
		}
	}
}
</style>
